/**
 * @packageDocumentation
 * @category Component
 */

import 'BomdisoftComponents/icons/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import { type IconGlyph, type IconOptions, toIconDimension } from 'BomdisoftComponents/icons/render';
import type { ReactNode } from 'react';

export type { IconColor } from 'BomdisoftComponents/icons/render';

export type IconGlyphProps = IconOptions;

type IconCircle = { cx: number; cy: number; r: number };

type BaseIconProps = IconGlyphProps & {
  glyph?: IconGlyph;
  path?: string | string[];
  circle?: IconCircle | IconCircle[];
  children?: ReactNode;
};

export const Icon = ({ glyph, path, circle, children, size = 24, color, className }: BaseIconProps) => {
  const dimension = toIconDimension(size);
  if (glyph) return <svg aria-hidden='true' className={joinClasses('bomdisoft-icon', className)} dangerouslySetInnerHTML={{ __html: glyph.markup }} data-color={color} fill='currentColor' height={dimension} viewBox='0 0 24 24' width={dimension} />;
  return (
    <svg aria-hidden='true' className={joinClasses('bomdisoft-icon', className)} data-color={color} fill='currentColor' height={dimension} viewBox='0 0 24 24' width={dimension}>
      {circle && [circle].flat().map(c => <circle cx={c.cx} cy={c.cy} key={`${c.cx}-${c.cy}-${c.r}`} r={c.r} />)}
      {path && [path].flat().map(d => <path d={d} key={d} />)}
      {children}
    </svg>
  );
};
